style= require('./duel-results.styl')
if match.season
  .wrapper.column
    .controls
      section
        a(href="/matches/" + match._id + "/lineups")
          ft-button(warning) Match Setup
        each source in matchSources
          if canScrapeLineups(source)
            ft-button(warning, (click)=this.scrapeLineups(source))
              | Scrape #{source.source}
        sporty-match-times(match=match)
        if canComputeAggregate
          ft-button(warning, (click)=this.computeAggregate())
            | Compute aggregate stats
        ft-button(success,
          (click)=this.sendFeeds(),
          disabled=match.$isSubmitting
        ) Send events
    .match
      sporty-status(match=match)
    ft-button(
      success,
      (click)=this.editMode = !this.editMode
    )= this.editMode ? 'Cancel' : 'Edit stats'
    .wrapper
      .stats
        h3 Teams/Managers
        sporty-stats.block(
          match=match,
          edit-mode=editMode,
          position='manager',
        )
      .wrapper.column.pairs
        each set in pairs
          - var pair = set[0]
          - var teams = set[1]
          .wrapper.column.pair
            h3 Duel #{pair}
            .wrapper
              each team in teams
                sporty-stats.block(
                  match=match,
                  team=team,
                  edit-mode=editMode,
                  exclude-positions='["manager"]'
                )
      .wrapper.duels.column
        each duel in duels
          .wrapper.teams
            each player in duel.duels[0].players
              .team(
                class={won: duel.event && duel.event.team === player.team, pick: duel.toResolve},
                (click)=this.addWinner(player, 'won_team_duel')
              )= player.team.name
          each duel in duel.duels
            .wrapper.duel
              each player, i in duel.players
                .player(
                  class={left: !i, won: isDuelWinner(player)},
                  (click)=this.addWinner(player)
                )= player.player.name
    sporty-feeds(match=match)
    if this.editMode
      ft-button(success, (click)=this.saveStats())
        | Save

  .events
    each event in (events || []).sort((a, b) => b.minute - a.minute)
      .event(class={submitting: event.$isSubmitting})
        if event.team
          .team(title=event.team.name)= event.team.short
        if event.player
          .name(title=event.player.fullName)= event.player.name
        .type= event.name
        ft-icon.delete(
          name="ui--cross",
          (click)=this.destroy(event)
        )
